"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_uuid_1 = __importDefault(require("react-uuid"));
const SessionControl_1 = require("../../helpers/session/SessionControl");
const config_1 = require("../config");
const tdcUrl = config_1.envConfig.apiURL && config_1.envConfig.apiURL.toString();
function customHeadersTDC(config) {
    var _a;
    const isTdcBaseURL = config.baseURL === tdcUrl;
    const urlIncludesTdc = (_a = config.url) === null || _a === void 0 ? void 0 : _a.includes(tdcUrl);
    if (!config.headers)
        config.headers = {};
    const configHeaders = config.headers;
    if (isTdcBaseURL || urlIncludesTdc) {
        configHeaders['x-user-id'] = SessionControl_1.User.getInstance().getUserId();
        configHeaders['x-correlation-id'] = (0, react_uuid_1.default)();
    }
    return config;
}
exports.default = customHeadersTDC;
